import axios from "axios";

export const getTicket = (data) => {
  return axios.post(process.env.TICKETING_URL, data, {
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": process.env.OCP_APIM_SUBSCRIPTION_KEY,
    },
  });
};

export const getRecurringTicket = (data) => {
  return axios.post(process.env.TICKETING_RECURRING_URL, data, {
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": process.env.OCP_APIM_SUBSCRIPTION_KEY,
    },
  });
};
